"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationImageOrIcon = NotificationImageOrIcon;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const types_1 = require("@src/types");
const streamline_icon_browser_page_text_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-browser-page-text.svg"));
const streamline_icon_single_neutral_actions_add_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-single-neutral-actions-add.svg"));
const streamline_icon_notes_paper_text_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-notes-paper-text.svg"));
const streamline_icon_calendar_3_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-calendar-3.svg"));
const streamline_icon_office_employee_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-office-employee.svg"));
const streamline_icon_view_1_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-view-1.svg"));
const streamline_icon_seo_search_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-seo-search.svg"));
const streamline_icon_information_circle_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-information-circle.svg"));
const streamline_icon_calendar_clock_svg_1 = __importDefault(require("@public/media/icons/streamline-icon-calendar-clock.svg"));
const styled_components_1 = __importStar(require("styled-components"));
const theme_1 = require("@src/styles/theme");
const elements_1 = require("@src/components/elements");
// this component is used above the ThemeProvider, so we have to access theme directly through import
const ImageOrIcon = styled_components_1.default.span `
	svg {
		color: ${theme_1.theme.color.gray6};
		transform: scale(0.9);
		width: 24px;
		${props => props.isNew &&
    (0, styled_components_1.css) `
				color: ${theme_1.theme.color.brand1};
			`}
	}
`;
function getNotificationIcon(notificationType) {
    switch (notificationType) {
        case types_1.NotificationType.COMPANY_SUBSCRIPTION_NOTIFICATION:
            return (0, jsx_runtime_1.jsx)(streamline_icon_browser_page_text_svg_1.default, { viewBox: "0 0 24 24" });
        case types_1.NotificationType.OFFER_SUBSCRIPTION_NOTIFICATION:
            return (0, jsx_runtime_1.jsx)(streamline_icon_browser_page_text_svg_1.default, { viewBox: "0 0 24 24" });
        case types_1.NotificationType.NEW_COMPANY_SUBSCRIBER_NOTIFICATION:
            return (0, jsx_runtime_1.jsx)(streamline_icon_single_neutral_actions_add_svg_1.default, { viewBox: "0 0 24 24" });
        case types_1.NotificationType.HIRING_PROCESS_RESULT_NOTIFICATION:
            return (0, jsx_runtime_1.jsx)(streamline_icon_seo_search_svg_1.default, { viewBox: "0 0 24 24" });
        case types_1.NotificationType.HIRING_PROCESS_CLOSED_NOTIFICATION:
            return (0, jsx_runtime_1.jsx)(streamline_icon_information_circle_svg_1.default, { viewBox: "0 0 24 24" });
        case types_1.NotificationType.NEW_OFFER_APPLICATION_NOTIFICATION:
            return (0, jsx_runtime_1.jsx)(streamline_icon_notes_paper_text_svg_1.default, { viewBox: "0 0 24 24" });
        case types_1.NotificationType.CREDITS_EXPIRATION_NOTIFICATION:
            return (0, jsx_runtime_1.jsx)(streamline_icon_calendar_3_svg_1.default, { viewBox: "0 0 24 24" });
        case types_1.NotificationType.NEW_CANDIDATE_INTERVIEW_NOTIFICATION:
            return (0, jsx_runtime_1.jsx)(streamline_icon_office_employee_svg_1.default, { viewBox: "0 0 24 24" });
        case types_1.NotificationType.COMPANY_VIEWED_RESUME_NOTIFICATION:
            return (0, jsx_runtime_1.jsx)(streamline_icon_view_1_svg_1.default, { viewBox: "0 0 24 24" });
        case types_1.NotificationType.CREDITS_PAID_NOTIFICATION:
            return (0, jsx_runtime_1.jsx)(elements_1.Icon, { type: "bank", width: 24 });
        case types_1.NotificationType.COMPANY_OFFER_DEADLINE_NOTIFICATION:
            return (0, jsx_runtime_1.jsx)(streamline_icon_calendar_clock_svg_1.default, { viewBox: "0 0 24 24" });
        default:
            return null;
    }
}
function NotificationImageOrIcon(props) {
    return ((0, jsx_runtime_1.jsxs)(ImageOrIcon, { isNew: props.isNew === undefined ? true : props.isNew, children: [props.imageUrl && (0, jsx_runtime_1.jsx)("img", { src: props.imageUrl, alt: "Notification" }), !props.imageUrl && getNotificationIcon(props.notificationType)] }));
}
